/**
 * Auto-resize textareas
 */

(function () {
    window._cc = window._cc || {};

    function autoResize(el) {
        el.style.height = 'auto';
        var cs = getComputedStyle(el);
        var border = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
        var rows = parseInt(el.getAttribute('rows')) || 1;
        var lineHeight = parseFloat(cs.lineHeight) || 20;
        var padding = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
        var minH = rows * lineHeight + padding + border;
        el.style.height = Math.max(el.scrollHeight + border, minH) + 'px';
    }

    function onInput(e) {
        autoResize(e.currentTarget);
    }

    function initAutoResize(el) {
        el.style.overflow = 'hidden';
        autoResize(el);
        // A named handler, so a second init of the same field adds no listener.
        el.addEventListener('input', onInput);
    }

    function initWithin(root) {
        if (root.matches('[data-autoresize]')) initAutoResize(root);
        root.querySelectorAll('[data-autoresize]').forEach(initAutoResize);
    }

    document.querySelectorAll('[data-autoresize]').forEach(initAutoResize);

    // Handle dynamically loaded content (sheets, HTMX swaps). htmx fires
    // htmx:load on each node it inserts, OOB swaps included, once settled.
    document.addEventListener('htmx:load', function (e) {
        initWithin(e.target);
    });

    // Re-measure when a dropdown opens. dropdowns.js dispatches `dropdown:open`
    // with the menu in event.detail — works for both portaled and inline menus
    // (a click-based DOM walk can't find the menu after it's been portaled to body).
    document.addEventListener('dropdown:open', function (e) {
        var menu = e.detail && e.detail.menu;
        if (!menu) return;
        menu.querySelectorAll('[data-autoresize]').forEach(autoResize);
    });

    // Re-measure when a collapse target opens (same problem as dropdowns:
    // scrollHeight is 0 while the element is display:none, so the initial
    // height is locked at `rows * lineHeight`. Re-run after the .collapse--open
    // class is toggled.)
    //
    // clamp.js handles [data-collapse-target] in two branches:
    //   1. Generic collapse — toggles .collapse--open on the queried selector(s)
    //   2. Collapsible card  — toggles .collapse--open on the .card--collapsible
    //                          itself when the trigger is its .card__title
    //                          (data-collapse-target value is ignored in this branch)
    // We need to cover both.
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-collapse-target]');
        if (!trigger) return;

        // Generic collapse: resolve the selector(s), if any
        var targetSelector = trigger.getAttribute('data-collapse-target');
        var targets = [];
        if (targetSelector) {
            targets = targetSelector.split(',')
                .map(function (s) { return document.querySelector(s.trim()); })
                .filter(Boolean);
        }

        // Collapsible card: clamp.js toggles .collapse--open on the card itself
        var card = null;
        if (trigger.matches('.card__title')) {
            card = trigger.closest('.card--collapsible');
        }

        if (!targets.length && !card) return;

        // Defer one frame so clamp.js has time to toggle .collapse--open
        requestAnimationFrame(function () {
            targets.forEach(function (t) {
                if (t.classList.contains('collapse--open')) {
                    t.querySelectorAll('[data-autoresize]').forEach(autoResize);
                }
            });
            if (card && card.classList.contains('collapse--open')) {
                card.querySelectorAll('[data-autoresize]').forEach(autoResize);
            }
        });
    });

    // A form reset clears values without firing `input`, so the inline height
    // from the last autoResize() sticks and the textarea stays tall but empty.
    // The `reset` event fires *before* the fields are cleared, so defer a frame.
    document.addEventListener('reset', function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        var fields = form.querySelectorAll('[data-autoresize]');
        if (!fields.length) return;
        requestAnimationFrame(function () {
            fields.forEach(autoResize);
        });
    }, true);

    // Expose for other modules
    window._cc.autoResize = autoResize;
    window._cc.initAutoResize = initAutoResize;

})();
